import { Injectable } from '@angular/core';

/**
 * Utilitaires liés au traitement d'images.
 *
 * Méthode principale : extractStaticBackground
 * Retourne l'URL originale pour les images non-GIF.
 * Pour un GIF, dessine le premier frame sur un <canvas> et retourne un dataURL PNG statique,
 * ce qui fige l'animation dans les contextes background-image.
 * En cas d'échec CORS ou canvas, retourne toujours l'URL originale en fallback sûr.
 */
@Injectable({ providedIn: 'root' })
export class ImageUtilsService {

  /**
   * @param url URL de l'image source
   * @returns Promise résolue avec l'URL à utiliser en background-image (statique si GIF)
   */
  extractStaticBackground(url: string): Promise<string> {
    if (!url || !url.toLowerCase().includes('.gif')) {
      return Promise.resolve(url);
    }

    return new Promise<string>((resolve) => {
      const img = new Image();
      // Requis pour pouvoir appeler toDataURL() sur un canvas cross-origin (Azure Blob)
      img.crossOrigin = 'anonymous';

      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            resolve(url);
            return;
          }
          ctx.drawImage(img, 0, 0); // Premier frame du GIF
          resolve(canvas.toDataURL('image/png'));
        } catch {
          // SecurityError possible si le serveur ne renvoie pas les en-têtes CORS
          resolve(url);
        }
      };

      img.onerror = () => resolve(url);
      img.src = url;
    });
  }
}
